document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("form").forEach((form) => {
    if (form.action !== `${location.origin}/cart/add`) {
      attachValidation(form);
    }
  });

  function attachValidation(form) {
    const submitButton = form.querySelector("button[type='submit']");

    if (!submitButton) return;

    submitButton.addEventListener("click", function (event) {
      event.preventDefault();
      if (validateForm(form)) {
        form.submit();
      }
    });

    form.querySelectorAll("input, textarea, select").forEach((field) => {
      field.addEventListener("input", function () {
        this.classList.remove("field--error");
        const error = this.parentNode.querySelector(".form__field-error");
        if (error) {
          error.remove();
        }
      });
    });
  }

  function validateForm(form) {
    let isValid = true;

    form
      .querySelectorAll(".form__field-error")
      .forEach((error) => error.remove());

    form
      .querySelectorAll("input[required], textarea[required], select[required]")
      .forEach((field) => {
        if (!field.value.trim()) {
          isValid = false;
          displayError(field, `${window.formValidation.required}`);
        } else if (field.value.length > 255) {
          isValid = false;
          displayError(field, `${window.formValidation.length_range}`);
        }
      });

    form.querySelectorAll("textarea").forEach((field) => {
      if (field.value.length > 255) {
        isValid = false;
        displayError(field, `${window.formValidation.length_range}`);
      }
    });

    const emailField = form.querySelector("input[type='email']");
    if (emailField && !validateEmail(emailField.value)) {
      isValid = false;
      displayError(emailField, `${window.formValidation.email}`);
    }

    const phoneField = form.querySelector("input[type='tel']");
    if (phoneField && !validatePhone(phoneField.value)) {
      isValid = false;
      displayError(phoneField, `${window.formValidation.telephone}`);
    }

    return isValid;
  }

  function validateEmail(email) {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(email);
  }

  function validatePhone(phone) {
    return /^[0-9]{10,}$/.test(phone.trim());
  }

  function displayError(field, message) {
    if (!field) return;

    let existingError = field.nextElementSibling;
    if (existingError?.classList.contains("form__field-error")) {
      existingError.innerHTML = `<span class="svg-wrapper"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <mask id="mask0_3016_455" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                                  <rect width="20" height="20" fill="#D9D9D9"/>
                                  </mask>
                                  <g mask="url(#mask0_3016_455)">
                                  <path d="M9.99497 13.5094C10.1608 13.5094 10.3013 13.4533 10.4164 13.3411C10.5316 13.229 10.5891 13.09 10.5891 12.924C10.5891 12.7582 10.533 12.6177 10.4208 12.5025C10.3086 12.3875 10.1696 12.33 10.0037 12.33C9.83789 12.33 9.6974 12.3861 9.58227 12.4982C9.46713 12.6104 9.40956 12.7494 9.40956 12.9153C9.40956 13.0811 9.46567 13.2216 9.57789 13.3367C9.69011 13.4519 9.82914 13.5094 9.99497 13.5094ZM9.45768 11.1921H10.541V6.16005H9.45768V11.1921ZM7.27977 16.5832L3.41602 12.7023V7.28025L7.27602 3.4165H12.7189L16.5827 7.2765V12.7194L12.7018 16.5832H7.27977Z" fill="#F00D0D"/>
                                  </g>
                                  </svg>
                                </span> ${message}`;
      return;
    }

    const error = document.createElement("small");
    error.className = "form__field-error";
    error.innerHTML = `<span class="svg-wrapper"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="mask0_3016_455" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                        <rect width="20" height="20" fill="#D9D9D9"/>
                        </mask>
                        <g mask="url(#mask0_3016_455)">
                        <path d="M9.99497 13.5094C10.1608 13.5094 10.3013 13.4533 10.4164 13.3411C10.5316 13.229 10.5891 13.09 10.5891 12.924C10.5891 12.7582 10.533 12.6177 10.4208 12.5025C10.3086 12.3875 10.1696 12.33 10.0037 12.33C9.83789 12.33 9.6974 12.3861 9.58227 12.4982C9.46713 12.6104 9.40956 12.7494 9.40956 12.9153C9.40956 13.0811 9.46567 13.2216 9.57789 13.3367C9.69011 13.4519 9.82914 13.5094 9.99497 13.5094ZM9.45768 11.1921H10.541V6.16005H9.45768V11.1921ZM7.27977 16.5832L3.41602 12.7023V7.28025L7.27602 3.4165H12.7189L16.5827 7.2765V12.7194L12.7018 16.5832H7.27977Z" fill="#F00D0D"/>
                        </g>
                        </svg>
                      </span> ${message}`;

    field.insertAdjacentElement("afterend", error);
    field.classList.add("field--error");
  }
});
